module.exports = __webpack_public_path__ + "assets/img/mg.409c2675.png";